import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import DividerFormFonts from './DividerFormFont'
import DividerFormStyle from './DividerFormStyle'
import type { DividerFormBrandType, DividerBrandForms } from './dividerTypes'

const FORM_MAP: DividerBrandForms = {
  [BrandFormEnum.STYLE]: DividerFormStyle,
  base: DividerFormFonts,
}

const DividerFormBrand: DividerFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(DividerFormBrand) as typeof DividerFormBrand
